<template>
    <div>
      <v-alert
        v-model="alert_transport"
        color="secondary"
        icon="mdi-truck"
        closable
        text="Darmowa dostawa kurierem i paczkomatem na terenie całej Polski!"
      ></v-alert>
      <v-row :class="margin">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <v-row class="align-center">
            <v-col cols="12" md="6">
              <v-row>
                <p class="text-h4">
                  {{ prod_name }}
                </p>
              </v-row>
              <v-row class="mt-5">
                <p class="subtitle-1">
                  Zrelaksuj się i pogrąż w błogim śnie z kołdrami Alpakowego Raju. Ekologiczne i hipoalergiczne, doskonałe zarówno latem jak i zimą, dzięki oddychającej strukturze wełny z alpak. Wybierz rozmiar oraz grubość wedle własnych preferencji.
                </p>
                <p class="subtitle-1 mt-3">
                  Kolor kołdry: Écru
                </p>
              </v-row>
              <br />
              <v-row class="mt-4">
                <v-select label="Rozmiar (w cm)" density="comfortable" :items="size" v-model="sizeval" variant="outlined"></v-select>
              </v-row>
              <v-row>
                <v-select label="Grubość" density="comfortable" :items="thickness" v-model="thickval" variant="outlined"></v-select>
              </v-row>
              <v-row class="mt-4">
                <p class="subtitle-1">
                  Czas realizacji: <font :color="availcolor"> {{ checkStorageStatus() }} </font>
                  <v-tooltip v-if="mobile==false" location="end" width="300" text="W przypadku obecności produktu w magazynie, czas realizacji wynosi ok. 1-2 dni robocze. Konieczność domówienia wydłuża czas realizacji do 2-3 tygodni.">
                    <template v-slot:activator="{ props }">
                      <v-icon icon="mdi-information" v-bind="props"></v-icon>
                    </template>
                  </v-tooltip>

                  <v-tooltip v-if="mobile==true" open-on-click location="end" width="300" text="W przypadku obecności produktu w magazynie, czas realizacji wynosi ok. 1-2 dni robocze. Konieczność domówienia wydłuża czas realizacji do 2-3 tygodni.">
                    <template v-slot:activator="{ props }">
                      <v-icon icon="mdi-information" v-bind="props"></v-icon>
                    </template>
                  </v-tooltip>
                </p>
              </v-row>
              <br />
              <v-row class="mt-4">
                <v-text-field
                  v-model="quantity"
                  label="Ilość"
                  placeholder="1"
                  density="comfortable"
                  type="number"
                  variant="outlined"
                ></v-text-field>
              </v-row>
              <v-row class="mt-5 justify-end">
                <p class="text-h4 text-primary">
                  {{price}}zł
                </p>
              </v-row>
              <v-row class="mt-6 align-center justify-end text-end">                
                Możliwość zakupu ratalnego z <v-img height="30" max-width="100" src='../assets/Shop/Przelewy24_logo.png'></v-img>
              </v-row>
              <v-row class="mt-6 justify-center">
                <v-btn size="x-large" prepend-icon="mdi-cart-plus" color="primary" @click="addProductToCart(prod_id, prod_name, sizeval, thickval, weightval, quantity, price)">Dodaj do koszyka</v-btn>
              </v-row>
            </v-col>
            <v-col cols="12" md="6">
              <v-carousel v-if="mobile==false" cycle height="600">
                <v-carousel-item
                  v-for="(item,i) in items"
                  :key="i"
                  :src="item.src"
                  cover
                ></v-carousel-item>
              </v-carousel>

              <v-carousel v-if="mobile==true" cycle height="300">
                <v-carousel-item
                  v-for="(item,i) in items"
                  :key="i"
                  :src="item.src"
                  cover
                ></v-carousel-item>
              </v-carousel>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
      <v-snackbar
        v-model="cart_snackbar"
        color="secondary"
      >
        Produkt został dodany do koszyka
        <template v-slot:actions>
          <v-btn
            icon="mdi-cart"
            color="white"
            @click="$router.push('/koszyk')"
          >            
          </v-btn>
          <v-btn
            icon="mdi-close"
            color="red"
            @click="cart_snackbar = false"
          >            
          </v-btn>
        </template>
      </v-snackbar>
    </div>
</template>

<script>
  import axios from 'axios'
  import { mapGetters, mapActions } from 'vuex';

  export default {
    data () {
      return {
        mobile: '',
        margin: 'ma-16',
        items: [
          {
            src: require('../assets/Duvets/carousel1.jpg'),
          },
          {
            src: require('../assets/Duvets/carousel2.jpg'),
          },
          {
            src: require('../assets/Duvets/carousel3.jpg'),
          },
          {
            src: require('../assets/Duvets/carousel4.jpg'),
          },
          {
            src: require('../assets/Duvets/carousel5.jpg'),
          },
          {
            src: require('../assets/Duvets/carousel6.jpg'),
          },
        ],
        prod_name: 'Kołdra',
        size: '',
        thickness: '',
        availcolor: '',
        sizeval: '140x200',
        thickval: 'całoroczna',
        weightval: '900',
        quantity: 1,
        price: 899,
        prod_id: 1,
        cart_snackbar: false,
        storageDB: [],
        alert_transport: true,
      }
    },
    created() {
      this.mobile = this.$vuetify.display.mobile
      if(this.mobile == true) {
        this.margin='my-2'
      }
    },
    methods: {
      ...mapActions([
        'addProduct',
        'currentProduct',
      ]),
      addProductToCart(product_id, name, size, thick, weight, quan, price) {
        var intquan
        //console.log(quan)
        if(quan===undefined || quan<1){
          intquan = 1
        } else {
          intquan = parseInt(quan)
        }
        var quanprice = price * intquan
        var product = {'id': product_id, 'prod_name': name, 'size': size, 'thickness': thick, 'weight': weight, 'quantity': intquan, 'price': quanprice}
        this.addProduct(product);
        this.cart_snackbar = true;
      },
      addCurrentProduct(product) {
        this.currentProduct(product);
      },
      checkStorageStatus() {
          //console.log(this.storageDB)
          for(let i = 0; i < this.storageDB.length; i++) {
              if(this.prod_id === this.storageDB[i].id_vuex) {
                  if (this.prod_id > 6 && this.prod_id <=12){
                    this.availcolor = ''
                    return "Produkt tylko na zamówienie (czas realizacji ok. 21 dni)"
                  }else if(this.storageDB[i].item_count > 0){
                    this.availcolor = "green"
                    return 'W magazynie'
                  } else {
                    this.availcolor = ''
                    return "Brak towaru - wymagane domówienie"
                  }
              }
          }
          return null;
      }
    },
    watch: {
      thickval: function() {
        this.price = this.$store.getters.getDuvetPrice(this.sizeval, this.thickval)[0]
        this.prod_id = this.$store.getters.getDuvetID(this.sizeval, this.thickval)[0]
        this.weightval = this.$store.getters.getDuvetWeight(this.sizeval, this.thickval)[0]

        this.checkStorageStatus(this.prod_id)
      },
      sizeval: function() {
        this.price = this.$store.getters.getDuvetPrice(this.sizeval, this.thickval)[0]
        this.prod_id = this.$store.getters.getDuvetID(this.sizeval, this.thickval)[0]
        this.weightval = this.$store.getters.getDuvetWeight(this.sizeval, this.thickval)[0]

        this.checkStorageStatus(this.prod_id)
      },

    },
    computed: {
      ...mapGetters([
        'getDuvets',
      ]),
    },
    beforeCreate() {
      axios
      .get(`${process.env.VUE_APP_API}/storage_status`)
      .then((resp) => {
          this.storageDB = resp.data;
      });
    },
    mounted() {
      this.checkStorageStatus(1);
      this.size = this.$store.getters.getDuvetsSizes;
      this.thickness = this.$store.getters.getDuvetsThickness;
    },
  }
</script>